<template>
<div class="zhuanZhengHome">
  <div class="topppp">
    <div class="topppp-r">
      <div>
        <p>顾客姓名</p>
        <el-input  size="small" class="srs" v-model="name" placeholder="请输入内容"></el-input>
        <p>顾客电话</p>
        <el-input  size="small" class="srs" v-model="tel" placeholder="请输入内容"></el-input>
      </div>
      <div>
        <p>转诊添加时间</p>
        <el-date-picker
            class="srs"
            size="small"
            v-model="time1"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
        </el-date-picker>
        <p>-</p>
        <el-date-picker
            class="srs"
            size="small"
            v-model="time2"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
        </el-date-picker>
      </div>
    </div>
    <h3>转诊列表</h3>
    <div>
      <el-button type="primary" @click="ss">搜索</el-button>
      <el-button type="primary" @click="dialogVisible = true">添加转诊</el-button>
    </div>
  </div>
  <ul class="btsss">
    <li>序号</li>
    <li>姓名</li>
    <li>联系方式</li>
    <li>转诊编号</li>
    <li>创建时间</li>
    <li>转诊类型</li>
    <li>预约时间</li>
    <li>转诊单位</li>
    <li>相关咨询</li>
    <li>备注</li>
    <li></li>
  </ul>
  <div class="nr-boxss">
    <ul class="nr-css" v-for="(item, idx) in list">
      <li>{{idx+1}}</li>
      <li>{{item.CustomerName}}</li>
      <li>{{item.CustomerTel}}</li>
      <li>{{item.ReferralId.slice(0,8)}}</li>
      <li>{{item.ReferralAddTime}}</li>
      <li>{{item.lx}}</li>
      <li>{{item.OppointmentTime}}</li>
      <li>{{item.ReferralShopName}}</li>
      <li>{{item.ReferralChooseId.slice(0,8)}}</li>
      <li>{{item.ReferralRemark}}</li>
      <li><el-button size="mini" @click="qxzz(item.ReferralOppointmentId)">取消</el-button></li>
    </ul>
  </div>


  <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="650px"
      >
    <p style="color: #0a0a0a;padding-bottom: 20px;">请选择:</p>
    <div class="hzdwzz" @click="$router.push({path: '/addZz'})">集团单位转诊</div>
    <div class="hzdwzz" @click="$router.push({path: '/addHzDw'})">合作单位转诊</div>
    <div class="hzdwzz" @click="$router.push({path: '/rwZz'})">任务转诊</div>
<!--     @click="$router.push({path: '/addHzDw'})"-->
    <el-button @click="dialogVisible = false">取 消</el-button>
  </el-dialog>
</div>
</template>

<script>
import {getZzLsit, Oppointment_Delete} from './api'
export default {
  name: "zhuanZhengHome",
  data() {
    return {
      name: '',
      tel: '',
      time1: '',
      time2: '',
      list: [],
      dialogVisible: false
    }
  },
  created() {
    this._api.expertClinic.getExSignature()
        .then(res => {
          if (res.GetResult) {
            this.$store.commit("expertClinic/upQmUrl", res.GetResult.UFPath)
          }
        })
    let ling = this.$loading({
      background: 'rgba(0, 0, 0, 0.7)',
      text: '加载中...'
    })
    getZzLsit()
    .then(res => {
      ling.close()
      if (res.Result && res.Result.length) {
        for (let i = 0; i < res.Result.length; i++) {
          if (res.Result[i].ReferralType == 0) res.Result[i].lx = '其他转诊'
          if (res.Result[i].ReferralType == 1) res.Result[i].lx = '门店转诊'
          if (res.Result[i].ReferralType == 2) res.Result[i].lx = '筛查转诊'
        }
        this.list = [...res.Result]
      }
    })
  },
  methods: {
    ss() {
      if (!this.time1 && this.time2) {
        return this.$alert('请选择开始或者结束时间！', '提示')
      }
      if (this.time1 && !this.time2) {
        return this.$alert('请选择开始或者结束时间！', '提示')
      }
      let ling = this.$loading({
        background: 'rgba(0, 0, 0, 0.7)',
        text: '加载中...'
      })
      getZzLsit(this.name,this.tel, this.time1, this.time2)
          .then(res => {
            ling.close()
            if (res.Result && res.Result.length) {
              for (let i = 0; i < res.Result.length; i++) {
                if (res.Result[i].ReferralType == 0) res.Result[i].lx = '其他转诊'
                if (res.Result[i].ReferralType == 1) res.Result[i].lx = '门店转诊'
                if (res.Result[i].ReferralType == 2) res.Result[i].lx = '筛查转诊'
              }
              this.list = [...res.Result]
            }else {
              this.list = []
            }
          })
    },
    qxzz(id) {
      this.$confirm('是否取消此转诊?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        Oppointment_Delete(id)
            .then(res => {
              this.$message({
                type: 'success',
                message: res.msg
              });
              this.ss()
            })
      }).catch(() => {
      });
    },
  }
}
</script>

<style scoped lang="scss">
.topppp {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  .topppp-r {
    div {
      display: flex;
      align-items: center;
      .srs {width: 120px;}
      padding-bottom: 5px;
      p {
        width: 6.5em;
      }
    }
  }
}
.btsss {
  display: flex;
  justify-content: space-between;
  background: #444444;
  color: #FFFFFF;
  padding: 8px 0;
  li{
    width: 10%;
  }
  li:nth-child(1) {
    width: 50px;
  }
  li:nth-child(11) {
    width: 80px;
  }
  li:nth-child(6) {
    width: 80px;
  }
}
.nr-boxss {
  height: calc(100vh - 290px);
  overflow-y: auto;
  .nr-css {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #c7c7c7;
    li{
      width: 10%;
      padding: 10px 0;
    }
    li:nth-child(1) {
      width: 50px;
    }
    li:nth-child(11) {
      width: 80px;
    }
    li:nth-child(6) {
      width: 80px;
    }
  }
}
.hzdwzz {
  width: 150px;
  margin: 0 auto;
  margin-bottom: 20px;
  padding: 5px 0;
  border: 1px solid #cdcdcd;
  border-radius: 5px;
  color: #0a0a0a;
  cursor: pointer;
}
</style>
